var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"config":_vm.config},on:{"on-close":function($event){return _vm.handleControl(_vm.timePickerValue)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }